import { FallbackItemImage } from "@coworker/apprestructured/src/shared/components/FallbackItemImage/FallbackItemImage";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import FurnitureSetIconPath from "@ingka/ssr-icon/paths/furniture-set";
import styles from "./item-image-local-combination.module.css";

export const ItemImageLocalCombination = () => {
  return (
    <FallbackItemImage
      classname={styles["fallback-item-image-container"] || ""}
    >
      <FixaSSRIcon
        className={styles["furniture-icon"] || ""}
        paths={FurnitureSetIconPath}
      />
    </FallbackItemImage>
  );
};
